module.exports = __webpack_public_path__ + "img/friends-logo5.d9405254.png";